<template>
    <b-row>
      <b-col md="8">
        <b-card no-body>
          <b-tabs card>
            <b-tab no-body v-for="file in files" :key="file.id" :title="`${file.id} ${file.name}`">
              <b-card-img bottom :src="fileUrl(file.id, sampleSetId)" :alt="`${file.id} ${file.name}`"></b-card-img>
              <!-- <b-card-footer>Picture 1 footer</b-card-footer> -->
            </b-tab>
          </b-tabs>
      </b-card>
      </b-col>
      <b-col>
        <slot name="form"></slot>
      </b-col>
    </b-row>
</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex';

export default {
  mounted() {
  },
  data() {
    return {
    };
  },
  props: {
    sample_id: { type: Number, default: null },
    label_set_id: { type: Number, default: null },
    info: { type: Object, default: null },
    label_objects: { type: Array, default: null },

  },
  components: {
  },
  computed: {
    files() { return this.info ? this.info.sample.files : []; },
    sampleSetId() { return this.info ? this.info.sample.sample_set_id : null; },
    ...mapState('Auth', ['activeProjectId', 'token']),
    ...mapState('Auth', ['activeProjectId']),
    ...mapGetters('Auth', ['fileUrl']),
  },
  methods: {
    save() {
      this.$emit('save-requested');
    },
  }
};
</script>

<style scoped>
</style>
